import { get } from 'lodash';
import i18next from 'i18next';
import React from 'react';

// Styles
import { Container } from './styledComponents';
import { Dropdown } from '@commons/utils/styledLibraryComponents';

// Commons
import {
  CONSUMPTION_FREQUENCY,
  getNonSalesConsumptionFrequencies,
} from '@admin/commons/constants/nonSalesConsumption';
import { formatTextNumberInputValue } from '@commons/utils/format';
import { Input } from '@lib/inpulse/Input';
import { translateUnit } from '@commons/utils/translateUnit';

const NonSalesConsumptionModal = (props) => {
  const {
    nonSalesConsumption,
    setModalConsumptionFrequency,
    setModalConsumptionQuantity,
    ingredientUnit,
    currency,
  } = props;

  const frequencies = getNonSalesConsumptionFrequencies(currency);

  const isDailyConsumption = nonSalesConsumption.frequency === CONSUMPTION_FREQUENCY.DAILY;

  const selectedFrequency = nonSalesConsumption.frequency
    ? {
        id: isDailyConsumption
          ? CONSUMPTION_FREQUENCY.DAILY
          : CONSUMPTION_FREQUENCY.PER_1000_CURRENCY,
        value: isDailyConsumption
          ? i18next.t('ADMIN.STORES.CONSUMPTION_FREQUENCY_DAILY')
          : i18next.t('ADMIN.STORES.CONSUMPTION_FREQUENCY_PER_1000_CURRENCY', {
              currency,
            }),
      }
    : null;

  return (
    <Container>
      <Dropdown
        items={frequencies}
        label={i18next.t('ADMIN.STORES.CONSUMPTION_FREQUENCY_COLUMN_TITLE')}
        placeholder={i18next.t('ADMIN.STORES.CONSUMPTION_FREQUENCY_COLUMN_TITLE')}
        selectedItem={selectedFrequency}
        tooltipText={i18next.t('ADMIN.STORES.CONSUMPTION_QUANTITY_COLUMN_TITLE_TOOLTIP', {
          currency,
        })}
        isRequired
        isSearchDisabled
        isUniqueSelection
        onSelectionChange={({ id }) => setModalConsumptionFrequency(id)}
      />

      <Input
        label={`${i18next.t('ADMIN.STORES.CONSUMPTION_QUANTITY_COLUMN_TITLE')} ${
          !!ingredientUnit ? ` (${translateUnit(ingredientUnit)})` : ''
        }`}
        placeholder={i18next.t('ADMIN.STORES.CONSUMPTION_QUANTITY_COLUMN_TITLE')}
        tooltipText={i18next.t('ADMIN.STORES.CONSUMPTION_FREQUENCY_COLUMN_TITLE_TOOLTIP', {
          currency,
        })}
        type="number"
        value={nonSalesConsumption.quantity === null ? '' : nonSalesConsumption.quantity}
        width={240}
        autoFocus
        textBig
        onChange={(e) => {
          const value = get(e.target, 'value');
          const formattedValue = formatTextNumberInputValue(value, null);

          setModalConsumptionQuantity(
            formattedValue !== null && formattedValue >= 0 ? formattedValue : null,
          );
        }}
      />
    </Container>
  );
};

export default NonSalesConsumptionModal;
